import { useState, ReactElement, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { LangeComponents } from '@/components';
import { useTranslation } from 'react-i18next';
import { useLogin } from '@/state/base/hooks';

const Layout = ({ children }): ReactElement => {
    let history = useHistory();
    const { t, i18n } = useTranslation();
    const [userInfo, login] = useLogin();
    const [showLange, setShowLange] = useState(false);
    const exincludeRoute = ['/governance-detail','/governance-add','/plan-detail','/node-detail']
    const pathOnly = `/${history.location.pathname.split('/')[1]}`
    const [title, setTitle] = useState({
        '/report': t('base.super rpc'),
        '/signup': t('signup.Supernode Campaign Registration'),
        '/governance-add': t('governance.Initiate voting governance'),
        '/governance-detail': t('proposal.Detail'),
        '/plan-detail': t('proposal.Detail'),
        '/node-detail': t('proposal.Detail'),
        '/report/detail': t('base.Candidate Details'),
    });

    useEffect(() => {
        setTitle({
            '/report': t('base.super rpc'),
            '/signup': t('signup.Supernode Campaign Registration'),
            '/governance-add': t('governance.Initiate voting governance'),
            '/governance-detail': t('proposal.Detail'),
            '/plan-detail': t('proposal.Detail'),
            '/node-detail': t('proposal.Detail'),
            '/report/detail': t('base.Candidate Details'),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n.language]);
    return (
       <div>
        <Main>
            <TopBar>
                <Left>
                    <Icon onClick={() => {
                        if (history.location.pathname ==='/signup' || exincludeRoute.includes(history.location.pathname)) {
                            history.goBack()
                        }else{
                            history.push('/vote-list')
                        }
                    }} className="iconfont back">
                        &#xe67c;
                    </Icon>
                    {title[history.location.pathname]}
                </Left>

                <Right>
                    <Wallet onClick={() => !userInfo.name && login()}>
                        <img src="/images/wallet.svg" alt="" />
                        {userInfo.name ? userInfo.name : t('base.connect wallet')}
                    </Wallet>

                    <LangeIcon src="/images/lange.svg" alt="" onClick={() => setShowLange(!showLange)} />
                    {showLange && <LangeComponents onClose={() => setShowLange(false)} />}
                </Right>
            </TopBar>
            <View>{children}</View>
        </Main>
       </div>
    );
};

export default Layout;

const Main = styled.div`
    width: 100%;
    height: 100%;
    padding: 0.45rem 0 0;
`;

const View = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background: #fff;
    @media screen and (min-width: 450px) {
        background: none;
    }
`;

const TopBar = styled.h4`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0.45rem;
    text-align: center;
    line-height: 0.45rem;
    font-weight: bold;
    color: #232323;
    background: #fff;
    z-index: 999;
    padding: 0 0.2rem;

    @media screen and (min-width: 450px) {
        background: none;
        width: 11rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        left: 50%;
        transform: translateX(-50%);
    }
    /* box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.25); */
`;

const Left = styled.div`
    position: relative;
    text-align: center;
    @media screen and (min-width: 450px) {
        text-align: left;
        padding-left: 60px;
    }
`;

const Icon = styled.i`
    font-size: 0.2rem;
    cursor: pointer;
    &.back {
        color: #000000;
        float: left;
        font-weight: 400;
        position: absolute;
        left: 0rem;
        top: 50%;
        transform: translateY(-50%);
        font-size: 0.2rem;
        @media screen and (min-width: 450px) {
            left: 0.2rem;
        }
    }
`;

const Right = styled.div`
    display: none;
    align-items: center;
    @media screen and (min-width: 450px) {
        display: flex;
    }
`;

const Wallet = styled.div`
    display: flex;
    align-items: center;
    font-family: 'Alibaba PuHuiTi 2.0';
    font-style: normal;
    font-weight: 400;
    font-size: 0.12rem;
    line-height: 0.17rem;
    color: #000000;
    padding: 0 0.08rem;
    min-width: 1.26rem;
    height: 0.28rem;
    border: 1px solid #000000;
    border-radius: 0.08rem;
    img {
        height: 0.17rem;
        margin-right: 0.04rem;
        margin-right: 0.19rem;
    }
`;

const LangeIcon = styled.img`
    height: 0.24rem;
    margin-left: 0.06rem;
    cursor: pointer;
`;
